<template>
  <div class="o-object-profile--landscape">
    <div
      class="o-object-profile__full-bleed-wrapper"
      :style="{ 'background-color': backgroundColor }"
    >
      <div class="o-object-profile--landscape__viewer">
        <slot name="viewer"></slot>
        <div class="o-object-profile--landscape__object-number">
          <slot name="objectNumber"></slot>
        </div>
        <div class="o-object-profile--landscape__alt-views">
          <slot name="altViews" />
        </div>
      </div>
    </div>
    <div class="o-object-profile--landscape__title-and-gallery">
      <div class="o-object-profile--landscape__title-gallery">
        <slot name="title"></slot>
      </div>
      <div v-if="isPart" class="o-object-profile--landscape__part-of">
        <slot name="partOf"></slot>
      </div>
    </div>
    <div class="o-object-profile--landscape__description">
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandscapeView",
  props: {
    /**
     * Background color for the viewer wrapper
     */
    backgroundColor: {
      type: String,
      required: false,
      default: undefined
    },
    /**
     * Where or not the object is part of a complex object
     */
    isPart: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "./landscape.scss";
</style>
